
<div class="card mb-0 mt-1 bg-color mx-3" *ngIf="isShow" (click)="onCardHandler()">
    <div class="card-body">
      <div class="d-flex align-items-center">
        <img
          [src]="imageSource"
          alt="image"
          class="me-3 d-none d-sm-block rounded-circle"
        />
        <div class="w-100 overflow-hidden">
          <h5 class="mb-1 header-title">{{cardTitle}}</h5>
          <p class="mb-0">{{cardDescription}}</p>
        </div>
        <!-- <span class="dragula-handle"></span> -->
      </div>
    </div>
  </div>